module.exports = __webpack_public_path__ + "static/media/vedant.0393e16e.jpg";